import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../redux/store";
import {
  setVisits,
  setVisitsFetched,
  setVisitsLoading,
} from "../redux/slices/visitsSlice";
import { api } from "../api/api";
import { VisitsResponse } from "../types/common";
import { getVisits } from "../api/visitsService";
import { useErrorBoundary } from "react-error-boundary";

export const useVisits = () => {
  const dispatch = useDispatch();
  const hasFetched = useSelector((state: RootState) => state.visits.hasFetched);
  const visits = useSelector((state: RootState) => state.visits.data);
  const isLoading = useSelector((state: RootState) => state.visits.isLoading);
  const { showBoundary } = useErrorBoundary();

  useEffect(() => {
    if (!hasFetched && !isLoading) {
      dispatch(setVisitsLoading(true));

      api<VisitsResponse>(getVisits())
        .then((visitsResponse) => {
          dispatch(setVisits(visitsResponse.data.visits));
        })
        .catch((error) => {
          dispatch(setVisitsFetched(true));
          showBoundary(error);
        })
        .finally(() => {
          dispatch(setVisitsLoading(false));
        });
    }
  }, [dispatch, hasFetched, isLoading]);

  return { visits, isLoading };
};
